import { FormTemplate } from "components/modal/templates";
import React from "react";
import { apply } from "sources/books/transportColumns";
import { config, initialState } from "../formConfig";
import Markup from "./markup";

class CreateTransportColumnsModal extends FormTemplate {
    sendRequest = (stateData) => apply(stateData);

    renderBodyInner = () => {
        const { config } = this.props;
        return <Markup {...config} renderField={this.renderField} />;
    };
}

const ConfiguredModal = (props) => (
    <CreateTransportColumnsModal {...props} config={config} initialState={initialState} />
);

export default ConfiguredModal;
